/**
 * Windows timezone ID → short abbreviation for compact display.
 * Single source for the maps that previously lived inline (divergently)
 * in Companies.tsx and CompanyView.tsx.
 */
const WINDOWS_TIMEZONE_ABBREVIATIONS: Record<string, string> = {
  // Australia
  'AUS Eastern Standard Time': 'AEST',
  'E. Australia Standard Time': 'AEST',
  'AUS Central Standard Time': 'ACST',
  'Cen. Australia Standard Time': 'ACST',
  'AUS Central W. Standard Time': 'ACWST',
  'W. Australia Standard Time': 'AWST',
  'Tasmania Standard Time': 'AEST',

  // North America
  'Eastern Standard Time': 'EST',
  'Central Standard Time': 'CST',
  'Mountain Standard Time': 'MST',
  'Pacific Standard Time': 'PST',
  'Alaska Standard Time': 'AKST',
  'Alaskan Standard Time': 'AKST',
  'Hawaiian Standard Time': 'HST',
  'Atlantic Standard Time': 'AST',

  // Europe
  'GMT Standard Time': 'GMT',
  'W. Europe Standard Time': 'CET',
  'Central Europe Standard Time': 'CET',
  'Central European Standard Time': 'CET',
  'Romance Standard Time': 'CET',
  'E. Europe Standard Time': 'EET',
  'FLE Standard Time': 'EET',
  'Russian Standard Time': 'MSK',

  // Asia
  'China Standard Time': 'CST',
  'Tokyo Standard Time': 'JST',
  'Korea Standard Time': 'KST',
  'India Standard Time': 'IST',
  'Singapore Standard Time': 'SGT',
  'Thailand Standard Time': 'ICT',
  'SE Asia Standard Time': 'ICT',

  // Others
  'UTC': 'UTC',
  'Coordinated Universal Time': 'UTC',
  'New Zealand Standard Time': 'NZST',
  'Fiji Standard Time': 'FJT',
};

/**
 * Short label for a (usually Windows-format) timezone name. Falls back to
 * pattern heuristics, then to a truncated form of the original string.
 */
export const getTimezoneAbbreviation = (timezone?: string | null): string => {
  if (!timezone) return '-';
  const tz = String(timezone).trim();

  // Already an abbreviation
  if (tz.length <= 6) return tz;

  const mapped = WINDOWS_TIMEZONE_ABBREVIATIONS[tz];
  if (mapped) return mapped;

  const lower = tz.toLowerCase();
  if (lower.includes('australia')) {
    if (lower.includes('eastern')) return 'AEST';
    if (lower.includes('central')) return 'ACST';
    if (lower.includes('western')) return 'AWST';
  }
  if (lower.includes('eastern')) return 'EST';
  if (lower.includes('central')) return 'CST';
  if (lower.includes('mountain')) return 'MST';
  if (lower.includes('pacific')) return 'PST';

  return tz.length > 8 ? `${tz.substring(0, 7)}…` : tz;
};
